import Image from "next/image";
import Link from "next/link";
import { getGlobalData } from "utils/api";
import { getLocalizedPaths } from "utils/localize";

import { RefreshHeader } from "@/components/brandRefresh/common/PageTemplate";

export default function HelpAndSupport({ metadata }) {
  const helpItems = [
    {
      title: "Customer care",
      description:
        "Find the support you need, whether it’s about accessibility, financial assistance, complaints, or authorising a third party to help manage your account.",
      iconUrl: "/images/help/heart-purple.png",
      iconAlt: "heart purple icon",
      link: "help/customer-care",
    },
    {
      title: "Fraud Prevention",
      description:
        "Find out how to report unusual activity on your account and get advice on protecting yourself from fraud.",
      iconUrl: "/images/help/shield.png",
      iconAlt: "shield icon",
      link: "help/fraud-prevention",
    },
    {
      title: "FAQs",
      description:
        "Quick answers to the most common questions about our services, products, and policies.",
      iconUrl: "/images/help/help-centre.png",
      iconAlt: "help center icon",
      link: "help/faq",
    },
    {
      title: "FX Calculator",
      description: "View the rates and charges for all our products.",
      iconUrl: "/images/howItWork/Calculator.png",
      iconAlt: "calculator icon",
      link: "help/fx",
    },
  ];

  return (
    <RefreshHeader metadata={metadata}>
      <div className="flex flex-col gap-spacing-12 lg:gap-spacing-14 text-sm lg:text-base 4xl:text-xl">
        <p className="text-center text-base lg:text-xl 4xl:text-2xl">
          Need assistance? We&apos;re here to help! Whether you have questions
          about our products, need guidance with your account, or are looking
          for support, you&apos;re in the right place.
        </p>
        <div className="grid lg:grid-cols-2 gap-spacing-7">
          {helpItems.map((item, index) => {
            return (
              <div
                className="h-[422px] lg:h-[482px] bg-onmoPurple-50 rounded-xl px-spacing-7 lg:px-8 py-spacing-12 flex flex-col justify-between"
                key={index}
              >
                <div>
                  <Image
                    src={item.iconUrl}
                    width={150}
                    height={150}
                    alt={item.iconAlt}
                    className="h-spacing-16 w-spacing-16 lg:h-spacing-17 lg:w-spacing-17"
                  />
                  <div className="flex flex-col mt-5">
                    <h4 className="text-onmoText font-medium text-xl lg:text-2xl 4xl:text-3xl mb-2">
                      {item.title}
                    </h4>
                    <p className="text-onmoText">{item.description}</p>
                  </div>
                </div>

                <Link href={item.link} className="flex items-center gap-3">
                  <p className="text-onmoPrimary font-medium">View</p>
                  <div className="h-5 w-5 flex items-center justify-center">
                    <Image
                      src={"/images/icons/arrow-right.svg"}
                      height={12}
                      width={14}
                      alt="arrow right"
                    />
                  </div>
                </Link>
              </div>
            );
          })}
        </div>
      </div>
    </RefreshHeader>
  );
}

export async function getServerSideProps(context) {
  const { locale, locales, defaultLocale } = context;
  const globalLocale = await getGlobalData(locale);

  const pageContext = {
    locale,
    locales,
    defaultLocale,
    slug: context.resolvedUrl.replace(/\//g, ""),
  };

  const localizedPaths = getLocalizedPaths(pageContext);

  const metadata = {
    metaTitle: `Help & Support`,
  };

  return {
    props: {
      metadata,
      global: globalLocale.data,
      pageContext: {
        ...pageContext,
        localizedPaths,
      },
    },
  };
}
